import React, { Fragment } from "react";
import { useEffect } from "react";
import { useConfig } from "../../core/config";
import { useAnalytics } from "../../lib/analytics/analytics";
import { makeGA4Client } from "../../lib/analytics/ga4";
import {
  makeOneSignalClient,
  OneSignalConfig,
} from "@/lib/analytics/onesignal";

export function useNomadworksAnalytics() {
  const config = useConfig();
  const analytics = useAnalytics();

  useEffect(() => {
    const variables = envVariables[config.environment];

    if (variables.ga4TrackingId) {
      const ga4Client = makeGA4Client({
        trackingId: variables.ga4TrackingId,
        gaOptions: {
          name: "nomadworks",
        },
      });

      analytics.addClient(ga4Client);
    }

    if (variables.oneSignalAppId) {
      const oneSignalConfig: Partial<OneSignalConfig> & { appId: string } = {
        appId: variables.oneSignalAppId,
        showPromoCode: true,
        promoCodeText: "WELCOMETONOMAD",
      };
      const oneSignalClient = makeOneSignalClient(oneSignalConfig);
      analytics.addClient(oneSignalClient);
    }
  }, [config.environment, analytics]);
}

const envVariables = {
  development: {
    ga4TrackingId: "",
    oneSignalAppId: "",
  },
  staging: {
    ga4TrackingId: "G-M3FMEW911N",
    oneSignalAppId: "",
  },
  production: {
    ga4TrackingId: "G-L67E757GRZ",
    oneSignalAppId: "d627a543-f806-4eb1-b565-7c2c925d1053",
  },
};

export default function NomadworksAnalytics(): JSX.Element {
  useNomadworksAnalytics();

  return <Fragment></Fragment>;
}
